import { ButtonProps } from '@stadionhq-v3/base-ui';
import { Button } from '../../button.component';

export const SecondaryButton = (props: ButtonProps) => (
  <Button variant="secondary" {...props} />
);

export default SecondaryButton;
